import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import client from '../api/client';
export default function Login() {
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [adminId, setAdminId] = useState('');
  const [otp, setOtp] = useState('');
  const [pin, setPin] = useState('');
  const [pin2, setPin2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const inp = { width:'100%', padding:'13px 16px', background:'#f9f9f9', border:'1px solid #ddd', borderRadius:8, color:'#000', fontSize:15, outline:'none', boxSizing:'border-box', marginBottom:12 };
  const btn = { width:'100%', padding:'13px', background:'linear-gradient(135deg,#1a5cff,#0e3db3)', color:'#000', border:'none', borderRadius:8, fontSize:15, fontWeight:700, cursor:loading?'not-allowed':'pointer', opacity:loading?0.7:1 };
  const sendOtp = async () => {
    if (!email) return setError('Enter your email');
    setLoading(true); setError('');
    try {
      const r = await client.post('/admin/auth/send-otp', { email });
      setAdminId(r.data.adminId); setMsg('OTP sent — check logs or email'); setStep('otp');
    } catch(e) { setError(e.response?.data || 'Failed'); } finally { setLoading(false); }
  };
  const verifyOtp = async () => {
    setLoading(true); setError('');
    try {
      const r = await client.post('/admin/auth/verify-otp', { adminId, otp });
      setMsg(''); setStep(r.data.status === 'SET_PIN' ? 'setpin' : 'pin');
    } catch(e) { setError(e.response?.data || 'Invalid OTP'); } finally { setLoading(false); }
  };
  const verifyPin = async () => {
    setLoading(true); setError('');
    try {
      const r = await client.post('/admin/auth/verify-pin', { adminId, pin });
      login(r.data.token, r.data.role, r.data.name); localStorage.setItem('admin_email', email); navigate('/');
    } catch(e) { setError(e.response?.data || 'Invalid PIN'); } finally { setLoading(false); }
  };
  const setNewPin = async () => {
    if (pin.length < 4) return setError('PIN must be at least 4 digits');
    if (pin !== pin2) return setError('PINs do not match');
    setLoading(true); setError('');
    try {
      const r = await client.post('/admin/auth/set-pin', { adminId, pin });
      login(r.data.token, r.data.role, r.data.name); localStorage.setItem('admin_email', email); navigate('/');
    } catch(e) { setError(e.response?.data || 'Failed'); } finally { setLoading(false); }
  };
  return (
    <div style={{ minHeight:'100vh', background:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <div style={{ background:'#fff', borderRadius:16, padding:'48px 40px', width:400, border:'1px solid #eee', boxShadow:'0 24px 80px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:52, height:52, background:'linear-gradient(135deg,#1a5cff,#0e3db3)', borderRadius:12, margin:'0 auto 12px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, fontWeight:700, color:'#000' }}>O</div>
          <div style={{ color:'#000', fontSize:20, fontWeight:700, fontFamily:'Georgia,serif' }}>OurEsign</div>
          <div style={{ color:'#555', fontSize:13, marginTop:4 }}>Admin Portal</div>
        </div>
        {error && <div style={{ background:'#fff5f5', border:'1px solid #5c2020', borderRadius:8, padding:'10px 14px', color:'#e05c5c', fontSize:13, marginBottom:16 }}>{error}</div>}
        {msg && <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:8, padding:'10px 14px', color:'#0a8a40', fontSize:13, marginBottom:16 }}>{msg}</div>}
        {step === 'email' && <><input style={inp} type="email" placeholder="admin@ouresign.com" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendOtp()} /><button style={btn} onClick={sendOtp}>{loading?'Sending...':'Send OTP'}</button></>}
        {step === 'otp' && <><input style={inp} placeholder="6-digit OTP" value={otp} onChange={e=>setOtp(e.target.value)} onKeyDown={e=>e.key==='Enter'&&verifyOtp()} maxLength={6} /><button style={btn} onClick={verifyOtp}>{loading?'Verifying...':'Verify OTP'}</button><button onClick={()=>setStep('email')} style={{ width:'100%', marginTop:8, padding:10, background:'transparent', color:'#555', border:'none', cursor:'pointer', fontSize:13 }}>← Back</button></>}
        {step === 'pin' && <><input style={inp} type="password" placeholder="Your PIN" value={pin} onChange={e=>setPin(e.target.value)} onKeyDown={e=>e.key==='Enter'&&verifyPin()} /><button style={btn} onClick={verifyPin}>{loading?'Signing in...':'Sign In'}</button></>}
        {step === 'setpin' && <><div style={{ color:'#000', fontSize:15, fontWeight:600, marginBottom:16 }}>Set your PIN (first time)</div><input style={inp} type="password" placeholder="New PIN (4-8 digits)" value={pin} onChange={e=>setPin(e.target.value)} maxLength={8} /><input style={inp} type="password" placeholder="Confirm PIN" value={pin2} onChange={e=>setPin2(e.target.value)} maxLength={8} /><button style={btn} onClick={setNewPin}>{loading?'Setting...':'Set PIN & Sign In'}</button></>}
      </div>
    </div>
  );
}
